export const TextEffectsNoisyViewerType = 'wixui.TextEffectsNoisy' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffectsNoisy-container',
    text: 'TextEffectsNoisy-text',
  },
} as const;

export const noiseIntensityConfig = {
  start: 1,
  end: 53,
  step: 1,
};
